export const common = {
  "home.awards.title": "Awards and recognition",
  "home.awards.pause": "Pause awards carousel",
  "home.awards.play": "Play awards carousel",
  "home.awards.financialAlgorithm": "Financial Algorithm Optimization Leader",
  "home.awards.asiaPacificGold": "Asia Pacific Gold Trading Leading Brand",
  "home.awards.preciousMetals": "Precious Metal Credible Brand",
  "home.awards.digitalFinance": "Digital Finance Innovation Contributor",
  "home.awards.quantitativeTrading": "Quantitative Trading Excellent Enterprise",
  // Navigation
  'nav.home': 'Home',
  'nav.trading': 'Trading',
  'nav.markets': 'Markets',
  'nav.news': 'News',
  'nav.about': 'About',
  'nav.contact': 'Contact',
  'nav.login': 'Login',
  'nav.register': 'Register',
  'nav.license': 'License',
  //
  // Hero Section
  'hero.title': 'Premium Gold & Silver Trading Platform',
  'hero.subtitle': 'Licensed Hong Kong company providing secure, professional precious metals trading for global investors',
  'hero.cta.start': 'Start Trading',
  'hero.cta.learn': 'Download MT5',

  //Home
   'home.licenseHK': 'Licensed in Hong Kong',
   'home.bankSec': 'Bank-Level Security',
   'home.247s': '24/7 Support',
   'home.global': 'Global Focus',
   'home.tradingPlat': 'Trading Platform',
   'home.tradingWith': 'Trade with ',
   'home.exp': 'Experience the worlds most advanced trading platform designed for precious metals trading.MT5 offers institutional-grade tools, lightning-fast execution, and comprehensive market analysis.',
   'home.dlMT5': 'Download MT5',
   'home.watchDemo': 'Watch Demo',
   'home.tradingIns': 'Trading Instruments',
   'home.exeSpeed': 'Execution Speed',   
   'home.mktAccess': 'Market Access',
   'home.uptime': 'Uptime',
   'home.allDevices': 'Available on all devices',
   'home.mktInt': 'Market Intelligence',
   'home.mktInt.desc': 'Stay informed with real-time economic events and market news that impact precious metals trading',
   'home.lastUpdate': 'Last updated',
   'home.ecoCal': 'Economic Calendar',
   'home.refresh': 'Refresh',
   'home.currency': 'Currency',
   'home.events': 'Events',
   'home.previous': 'Previous',
   'home.forecast': 'Forecast',
   'home.actual': 'Actual',
   'home.mktNews': 'Market News',
   'home.seeMore': 'See More',
   'home.ecoData': 'Economic data powered by multiple financial data providers • Market news from leading financial publications',
   'home.ac': 'Advanced Charting',
   'home.pta': 'Professional technical analysis with 80+ indicators and analytical tools',
   'home.mpa': 'Multi-Platform Access',
   'home.tsa': 'Trade seamlessly across desktop, web, and mobile applications',
   'home.st': 'Secure Trading',
   'home.bls': 'Bank-level security with encrypted data transmission and storage',
   'home.247': '24/7 Market Access',
   'home.rtc': 'Round-the-clock trading access to global precious metals markets',
   'home.at': 'Automated Trading',
   'home.ea': 'Expert Advisors (EAs) for algorithmic and automated trading strategies',
   'home.lfe': 'Lightning Fast Execution',
   'home.ull': 'Ultra-low latency order execution with competitive spreads',

  // Features
  'features.title': 'Why Choose Our Platform',
  'features.security.title': 'Bank-Level Security',
  'features.security.desc': 'Advanced encryption and multi-layer security protocols protect your investments',
  'features.licensed.title': 'Fully Licensed',
  'features.licensed.desc': 'Regulated Hong Kong company with full compliance and transparency',
  'features.realtime.title': 'Real-Time Trading',
  'features.realtime.desc': 'Live market data and instant execution for optimal trading opportunities',
  'features.support.title': '24/7 Support',
  'features.support.desc': 'Professional multilingual support team available around the clock',
  'features.lmd': 'Live Market Data',
  'features.rtp': 'Real-time precious metals prices',
  
  // Markets
  'markets.title': 'Live Market Prices',
  'markets.gold': 'Gold',
  'markets.silver': 'Silver',
  'markets.platinum': 'Platinum',
  'markets.palladium': 'Palladium',
  'markets.price': 'Price',
  'markets.change': 'Change',
  'markets.high': '24h High',
  'markets.low': '24h Low',
  'markets.contractDetials' : 'Contract Details',
  'markets.contractDetials.desc' : 'Comprehensive contract specifications and trading conditions for precious metals',
  'markets.tradingExample' : 'Trading Example',
  'markets.goldExample' : 'Gold Trading Example',
  'markets.silverExample' : 'Silver Trading Example',
  'markets.instrument' : 'Instrument',
  'markets.lotSize' : 'Lot Size',
  'markets.entPrice' : 'Entry Price',
  'markets.marReq' : 'Margin Required',
  'markets.pip' : 'Pip Value',
  'markets.pmt' : 'Precious Metals Trading',
  'markets.ctt' : 'Comprehensive trading terms, conditions, and specifications for precious metals trading. Understand contract details, margin requirements, and risk management for gold and silver investments.',
  'markets.vts' : 'View Trading Specs',
  'markets.dcd' : 'Download Contract Details',
  'markets.ec' : 'Execution Speed',
  'markets.th' : 'Trading Hours',
  'markets.ms' : 'Min Spread (pips)',
  'markets.ml' : 'Max Leverage',
  'markets.mr' : 'Margin Requirements',
  'markets.lo' : 'Leverage options and margin requirements for different account types',
  'markets.leverage' : 'Leverage',
  'markets.margin' : 'Margin',
  'markets.mind' : 'Minimum Deposit',
  'markets.mc' : 'Margin Calculator',
  'markets.gmc' : 'Gold Margin Calculation',
  'markets.cp' : 'Current Price',
  'markets.cv' : 'Contract Value',
  'markets.smc' : 'Silver Margin Calculation',
  'markets.rm' : 'Risk Management',
  'markets.crm' : 'Comprehensive risk management tools and strategies to protect your investments',
  'markets.rtg' : 'Risk Tolerance Guide',
  'markets.rd' : 'Risk Disclosure',
  'markets.tpm' : 'Trading precious metals involves substantial risk of loss and may not be suitable for all investors. Past performance is not indicative of future results.',
  'markets.lcw' : 'Leverage can work against you as well as for you. Before deciding to trade, you should carefully consider your investment objectives, level of experience, and risk appetite.',
  'markets.ysb' : 'You should be aware of all the risks associated with precious metals trading and seek advice from an independent financial advisor if you have any doubts.',
  'markets.rfr' : 'Read Full Risk Disclosure',
  'markets.cra' : 'Contact Risk Advisor',
  'markets.tho' : 'Trading Hours',
  'markets.moh' : 'Market operating hours and holiday schedule for precious metals trading',
  'markets.wts' : 'Weekly Trading Schedule',
  'markets.note' : 'Note',  
  'markets.atad' : 'All times are displayed in GMT+8. Trading may be suspended during major holidays and market volatility periods.',
  'markets.hs' : 'Holiday Schedule',
  'markets.mclo' : 'Market Closed',
  'markets.eclo' : 'Early Close',  
  'markets.hn' : 'Holiday Notice',
  'markets.thm' : 'Trading hours may be adjusted during national holidays. Please check our announcements for any schedule changes.',  
  'markets.cms' : 'Current Market Status',  
  'markets.mac' : 'Markets are currently OPEN for trading',
  'markets.st' : 'Server Time (GMT+8)', 
  'markets.ts' : 'Trading Specifications',
  'markets.dtc' : 'Detailed trading conditions and specifications for gold and silver instruments',
  'markets.msp' : 'Min Spread',  
  'markets.minls' : 'Min Lot Size',
  'markets.maxls' : 'Max Lot Size',  
  'markets.commission' : 'Commission',  
  'markets.sls' : 'Swap Long/Short',
  'markets.in' : 'Important Notes', 
  'markets.smv' : 'Spreads may vary during high volatility periods and major news events',  
  'markets.sra' : 'Swap rates are updated daily and may change based on market conditions',  
  'markets.mlm' : 'Maximum leverage may be reduced during high-impact news events',
  'markets.ata' : 'All times are displayed in GMT+8 timezone', 

  // News
  'news.title': 'Latest Market News & Analysis',
  'news.subtitle': 'Stay informed with expert insights and market updates',
  'news.readMore': 'Read More',
  'news.category.analysis': 'Market Analysis',
  'news.category.news': 'Breaking News',
  'news.category.insights': 'Expert Insights',
  'news.category.education': 'Education',
  'news.date': 'Published',
  'news.author': 'By',
  
  // Testimonials
  'home.partners.title': 'Our Partners',
  'home.partners.subtitle': 'Working with leading global liquidity, financial technology and trading infrastructure providers.',
  'testimonials.title': 'Trusted by Investors Worldwide',
  'testimonials.client1.name': 'Marcus Weber',
  'testimonials.client1.location': 'Frankfurt, Germany',
  'testimonials.client1.text': 'Excellent platform with transparent pricing and reliable execution. The security features give me complete confidence.',
  'testimonials.client2.name': 'Sophie Dubois',
  'testimonials.client2.location': 'Paris, France',
  'testimonials.client2.text': 'Professional service and competitive spreads. The multilingual support team is incredibly helpful.',
  'testimonials.client3.name': 'Alessandro Rossi',
  'testimonials.client3.location': 'Milan, Italy',
  'testimonials.client3.text': 'Fast execution and excellent market analysis tools. Highly recommended for serious precious metals trading.',
  
  // Footer
  'footer.company': 'Company',
  'footer.trading': 'Trading',
  'footer.support': 'Support',
  'footer.legal': 'Legal',
  'footer.about': 'About Us',
  'footer.careers': 'Careers',
  'footer.news': 'News',
  'footer.platforms': 'Trading Platforms',
  'footer.education': 'Education',
  'footer.analysis': 'Market Analysis',
  'footer.help': 'Help Center',
  'footer.contact': 'Contact Us',
  'footer.faq': 'FAQ',
  'footer.terms': 'Terms of Service',
  'footer.privacy': 'Privacy Policy',
  'footer.risk': 'Risk Disclosure',
  'footer.copyright': '© 2024 GOLD Label Global Limited. All rights reserved.',
  'footer.license': "Hong Kong incorporated company",
  'footer.riskwarning': 'Risk Warning',
  'footer.disclaimer':'Margin trading is a leveraged financial product that may result in losses exceeding your deposits. You do not actually own or hold any underlying assets. Please carefully read our Risk Disclosure Statement before trading. Make sure you fully understand the risks involved and manage your exposure prudently. We accept no liability for any actions or inactions taken by individuals based on the information on this website or its content.',
  'footer.jurisdiction': "Jurisdictional Notice",
  'footer.jurisdictionDisclaimer': "Services are offered to eligible clients in jurisdictions outside Hong Kong and the United States, provided that the provision of such services is lawful under the applicable laws of the client's jurisdiction. Services are not offered to residents of Hong Kong or the United States, or to any person in any jurisdiction where such services would be unlawful or prohibited. This website is not directed at, and does not constitute an offer, solicitation or recommendation to, any person in a restricted jurisdiction.",
  'footer.relatedEntity': 'Other Related Entity',
  'footer.saintLuciaEntity': "Gold Label Global (SL) Limited is an International Business Company incorporated in Saint Lucia on 4 September 2026, registration number 2026-00680. Registered office: Ground Floor, The Sotheby Building, Rodney Village, Rodney Bay, Gros-Islet, Saint Lucia. The registered office is maintained solely for statutory and regulatory compliance. It is not the Company's operational business premises and is not used for operations, customer visits or correspondence.",
  'footer.regNo': 'Company registration number',
  // Common
  'common.language': 'Language',
  'common.loading': 'Loading...',
  'common.error': 'Error',
  'common.success': 'Success',
  'common.close': 'Close',
  'common.save': 'Save',
  'common.cancel': 'Cancel',
  'common.continue': 'Continue',
  'common.back': 'Back',
  'common.next': 'Next',
  'common.previous': 'Previous',
  'common.submit': 'Submit',
  'common.reset': 'Reset',

//About
  'about.yearsOfExp': 'Years of Experience',
  'about.yearsOfExp.desc': 'Decades of expertise in precious metals trading',
  'about.dailyTrade': 'Daily Trading Volume',
  'about.dailyTrade.desc': 'HK$80 billion in daily gold and silver transactions',
  'about.satClients': 'Satisfied Clients',
  'about.satClients.desc': 'Serving countless clients and institutions worldwide',
  'about.exeSpeed': 'Execution Speed',
  'about.exeSpeed.desc': 'Lightning-fast trade execution technology',
  'about.ourAch': 'Our Achievements',
  'about.ourAch.desc': 'Recognized excellence in precious metals trading with industry-leading performance',
  'about.companyProfile': 'Company Profile',
  'about.about1': 'About Gold Label Global',
  'about.about2': 'Gold Label Global Limited is a registered limited company approved by the Hong Kong government and is also a member of the Chinese Gold and Silver Exchange Society. Hong Kong processes daily gold and silver transactions worth HK$80 billion, with experience leading the world.',
  'about.about3': 'Gold Label Globals management team has over twenty years of focused experience in gold and silver trading. We have previously served countless clients and institutions, handling client transactions exceeding tens of billions. We have received high praise from clients and industry professionals.',
  'about.about4': 'We are committed to providing clients with fast, stable, and excellent trading environments. Technically, we adopt international-level trading systems and select top-tier technology teams to develop more powerful and comprehensive trading programs, improving trading speed to be faster, more stable, and more comprehensive.',
  'about.about5': 'Gold Label Global will continue to create profits with you and share prosperity together.',
  'about.about6': 'Discover our journey in precious metals trading and our commitment to excellence in the global financial markets.',
  'about.about7': 'As a registered limited company approved by the Hong Kong government and a member of the Chinese Gold & Silver Exchange Society, we handle HK$80 billion in daily gold and silver transactions, leading the world in trading experience.',
  'about.proTeam': 'Professional Team',
  'about.proTeam.desc': 'Our management team has over 20 years of experience focusing on gold and silver trading, having served countless clients and institutions.',
  'about.proService': 'Professional Service',
  'about.proService.desc': 'Professional customer team providing 24-hour online customer service and mobile customer service consultation, as well as targeted solutions for customer problems.',
  'about.sec': 'Security First',
  'about.sec.desc': 'No trading counterparty, transactions directly enter the market, transactions are open and transparent, safe and secure.',
  'about.strict': 'Strict Supervision',
  'about.strict.desc': 'Gold Label Global is a Hong Kong commercial trading venue, regulated by the Hong Kong government, and is a member of the Hong Kong Commercial Trading Association.',
  'about.fastDes': 'Fast Deposit',
  'about.fastDes.desc': 'Provide 24-hour industry business, second deposit, instant account opening.',
  'about.productSafe': 'Product Safety',
  'about.productSafe.desc': 'Covering all major global precious metal products, safe and secure.',
  'about.whyGLB': 'Why Choose Gold Label Global',
  'about.whyGLB.desc': 'Discover the advantages that make us the leading choice for precious metals trading',
  'about.readyToStart': 'Ready to Start Trading?',
  'about.join': 'Join thousands of satisfied clients who trust GOLD Label Global for their precious metals trading needs.',
  'about.openTradingAcc': 'Open Trading Account',
  'about.contactTeam': 'Contact Our Team',
  'about.co': 'Cooperation',
  'about.co.desc': 'Building mutually beneficial partnerships with our clients and stakeholders',
  'about.safety': 'Safety',
  'about.safety.desc': 'Ensuring the highest level of security for all trading activities',
  'about.integrity': 'Integrity',
  'about.integrity.desc': 'Maintaining the highest standards of honesty and transparency',
  'about.professional': 'Professional',
  'about.professional.desc': 'Delivering expert services with unmatched professionalism',
  'about.fast': 'Fast',
  'about.fast.desc': 'Providing rapid execution and responsive customer service',
  'about.coreValue': 'Our Core Values',
  'about.coreValue.desc': 'The principles that guide our commitment to excellence in precious metals trading',

  //Contact  
  'contact.sendUsMsg': 'Send Us a Message',
  'contact.fillOut': 'Fill out the form below and our team will get back to you within 24 hours.',
  'contact.inqType': 'Inquiry Type',
  'contact.genInq': 'General Inquiry',
  'contact.accSup': 'Account Support',
  'contact.traSup': 'Trading Support',
  'contact.techSup': 'Technical Support',
  'contact.partner': 'Partnership',
  'contact.fullname': 'Full Name *',
  'contact.email': 'Email Address *',
  'contact.phone': 'Phone Number',
  'contact.subject': 'Subject *',
  'contact.msg': 'Message *',
  'contact.sendMsg': 'Send Message',
  'contact.whyUs': 'Why Choose Us?',
  'contact.regSec': 'Regulated & Secure',
  'contact.licAndReg': 'Licensed and regulated trading environment with advanced security measures to protect your investments.',
  'contact.expSup': 'Expert Support',
  'contact.proService': 'Professional trading specialists available 24/7 to assist with your trading needs and questions.',
  'contact.fastExe': 'Fast Execution',
  'contact.lightFast': 'Lightning-fast order execution with minimal slippage for optimal trading performance.',
  'contact.glbNet': 'Global Markets',
  'contact.asscessToint': 'Access to international precious metals markets with competitive spreads and deep liquidity.',
  'contact.followUs': 'Follow us on social media:',
  'contact.contactOutPro': 'Contact our professional team for trading support, account assistance, or general inquiries:',
  'contact.officeAddress': 'Office Address',
 'contact.bussHour': 'Business Hours: Mon-Fri 9:00-18:00 (GMT+8)',
 'contact.phoneSupp': 'Phone Support',
 'contact.mainOffice': 'Main Office',
 'contact.availableServices': 'Available Services:',
 'contact.accOpenSup': 'Account Opening Support',
 'contact.tradSup': 'Trading Platform Assistance',
 'contact.genSup': 'General Support',
 'contact.emailSup': 'Email Support',
 'contact.responseTime': 'Response Time:',
 'contact.genInq24': 'General Inquiries: Within 24 hours',
 'contact.techSup24': 'Technical Support: Within 4 hours',
 'contact.accIss24': 'Account Issues: Within 2 hours',
 'contact.needImSup': 'Need Immediate Assistance?',
 'contact.needImSup.desc': 'Our trading specialists are available 24/7 to help you with urgent trading matters and account support.',
 'contact.callNow': 'Call Now',
 'contact.sendEmail': 'Send Email',
 'contact.contactUs': 'Contact Us',
 'contact.getInTouch': 'Get in touch with our professional trading team. We are here to help you succeed in precious metals trading.',
 'contact.247Sup': '24/7 Support',
 'contact.247Sup.desc': 'Round-the-clock customer service for all your trading needs',
 'contact.dirLine': 'Direct Line',
 'contact.dirLine.desc': 'Speak directly with our trading specialists',
 'contact.hkOffice': 'Hong Kong Office',
 'contact.hkOffice.desc': 'Located in the heart of Hong Kong financial district',

//Platform
 'platform.wco': 'Why Choose Our MT5 Platform?',
 'platform.etd': 'Experience the difference with our premium trading platform designed for serious traders',
 'platform.rts': 'Ready to Start Trading?',
 'platform.jto': 'Join thousands of traders who trust our platform for their precious metals trading',
 'platform.ola': 'Open Live Account',
 'platform.tda': 'Try Demo Account',
 'platform.dmt': 'Download MT5 Platform',
 'platform.ayt': 'Access your trading account from any device with our multi-platform MT5 applications',
 'platform.free': 'Free',
 'platform.dn': 'Download Now',
 'platform.sr': 'System Requirements',
 'platform.nh': 'Need Help Getting Started?',
 'platform.os': 'Our support team is ready to help you set up and start trading',
 'platform.ug': 'User Guide',
 'platform.cs': 'Contact Support', 
 'platform.si': 'Stable internet connection required',
 'platform.ptf': 'Powerful Trading Features', 
 'platform.epg': 'Experience professional-grade trading tools designed for both beginners and expert traders',
 'platform.ac': 'Advanced Charting', 
 'platform.pct': 'Professional charting tools with 80+ technical indicators and multiple timeframes for comprehensive market analysis.',
 'platform.lfe': 'Lightning Fast Execution', 
 'platform.ull': 'Ultra-low latency trading with execution speeds as fast as 0.01 seconds for optimal trade entry and exit.',
 'platform.ea': 'Expert Advisors (EAs)', 
 'platform.atc': 'Automated trading capabilities with custom Expert Advisors and algorithmic trading strategies.',
 'platform.rm': 'Risk Management', 
 'platform.crm': 'Comprehensive risk management tools including stop loss, take profit, and position sizing controls.',
 'platform.mpa': 'Multi-Platform Access', 
 'platform.tsa': 'Trade seamlessly across desktop, web, and mobile platforms with synchronized account access.', 
 'platform.gm': 'Global Markets', 
 'platform.ati': 'Access to international markets including precious metals, forex, indices, and commodities.', 
 'platform.etw': 'Experience the worlds most advanced trading platform. Trade precious metals, forex, and CFDs with institutional-grade technology and lightning-fast execution.',
 'platform.download': 'Download ',
 'platform.wd': 'Watch Demo',
 'platform.es': 'Execution Speed',
 'platform.th': 'Trading Hours',
 'platform.in': 'Instruments',
 'platform.lt': 'Live Trading',
 'platform.ptt': 'Professional Trading Tools',
 'platform.aig': 'Access institutional-grade trading tools designed for professional traders and serious investors',
 'platform.rtd': 'Real-time Data',
 'platform.lmd': 'Live market data and instant price updates',
 'platform.pa': 'Price Alerts',
 'platform.caf': 'Custom alerts for price movements and market events',
 'platform.this': 'Trade History',
 'platform.cth': 'Comprehensive trading history and performance analytics',
 'platform.ec': 'Economic Calendar',
 'platform.suw': 'Stay updated with important economic events',
 'platform.mw': 'Market Watch',
 'platform.rtp': 'Real-time price quotes and market depth for all available instruments',
 'platform.om': 'Order Management',
 'platform.aot': 'Advanced order types including market, limit, stop, and trailing stop orders',
 'platform.ta': 'Technical Analysis',
 'platform.cta': 'Comprehensive technical analysis tools with custom indicators and drawing tools', 
 'platform.ufe': 'Ultra-Fast Execution', 
 'platform.rtc': 'Round-the-clock customer support from our team of trading experts and technical specialists',
 'platform.247a': '24/7 Available', 
 'platform.csp' : 'Competitive Spreads',
 'platform.iia': 'Industry-leading spreads and transparent pricing with no hidden fees or commissions',
 'platform.01pip': 'From 0.1 pips',
 'platform.ffd': 'Full-featured desktop application for Windows 10/11',
 'platform.nma': 'Native macOS application with full functionality',
 'platform.mta': 'Mobile trading app for Android devices',
 'platform.iai': 'iPhone and iPad trading application', 

  // FAQ SECTION
  // ─────────────────────────────
  'faq.tagline': 'HOW CAN WE HELP YOU?',
  'faq.title': 'How Can We Help You?',
  'faq.subtitle': 'Browse through our comprehensive FAQ sections to find quick answers to your questions',
  'faq.categories': 'Categories',

  // Footer help box
  'faq.cantFind': "Can't Find What You're Looking For?",
  'faq.supportText': 'Our support team is here to help you with any questions not covered in our FAQ section.',
  'faq.contactSupport': 'Contact Support Team',

  // Category titles
  'faq.general': 'General',
  'faq.account': 'Account',
  'faq.trading': 'Trading',
  'faq.platform': 'Platform',
  'faq.deposits': 'Deposits & Withdrawals',
  'faq.security': 'Security',

  // ─────────── General ───────────
  'faq.general.q1': 'What is GOLD LABEL GLOBAL LIMITED?',
  'faq.general.a1': 'GOLD LABEL GLOBAL LIMITED is a regulated precious metals trading company based in Hong Kong, offering professional trading services for gold, silver, and other precious metals through the MT5 platform.',
  'faq.general.q2': 'What trading instruments do you offer?',
  'faq.general.a2': 'We offer a comprehensive range of precious metals including spot gold (XAU/USD), spot silver (XAG/USD), platinum, palladium, and various precious metals futures contracts.',
  'faq.general.q3': 'What are your trading hours?',
  'faq.general.a3': 'Our precious metals markets are open 24 hours a day, 5 days a week, from Sunday 5:00 PM EST to Friday 4:00 PM EST, following international market hours.',
  'faq.general.q4': 'Is my investment safe with your company?',
  'faq.general.a4': 'Yes, we are fully regulated and licensed. Client funds are segregated and held in secure bank accounts. We also maintain comprehensive insurance coverage for additional protection.',

  // ─────────── Account ───────────
  'faq.account.q1': 'How do I open a trading account?',
  'faq.account.a1': 'You can open an account online by completing our application form, providing required identification documents, and making an initial deposit. The process typically takes 1–2 business days.',
  'faq.account.q2': 'What is the minimum deposit required?',
  'faq.account.a2': 'The minimum initial deposit is $1,000 USD for a standard account. We also offer premium accounts with higher minimum deposits and additional benefits.',
  'faq.account.q3': 'Can I have multiple trading accounts?',
  'faq.account.a3': 'Yes, you can open multiple trading accounts with different base currencies or account types to suit your various trading strategies and risk management needs.',
  'faq.account.q4': 'How do I verify my account?',
  'faq.account.a4': 'Account verification requires a government-issued ID (passport or driver’s license) and proof of address (utility bill or bank statement) dated within the last 3 months.',

  // ─────────── Trading ───────────
  'faq.trading.q1': 'What is the minimum trade size?',
  'faq.trading.a1': 'The minimum trade size is 0.01 lots for most precious metals instruments. This allows for flexible position sizing and risk management for traders of all levels.',
  'faq.trading.q2': 'What leverage do you offer?',
  'faq.trading.a2': 'We offer competitive leverage up to 1:100 for precious metals trading, allowing you to maximize your trading potential while maintaining responsible risk management.',
  'faq.trading.q3': 'Are there any trading fees?',
  'faq.trading.a3': 'We operate on a spread-based model with no commission fees. Our spreads are competitive and transparent, with no hidden costs or surprise charges.',
  'faq.trading.q4': 'Can I use automated trading strategies?',
  'faq.trading.a4': 'Yes, our MT5 platform fully supports Expert Advisors (EAs) and automated trading strategies. You can develop custom algorithms or use existing trading robots.',

  // ─────────── Platform ───────────
  'faq.platform.q1': 'Which trading platforms do you support?',
  'faq.platform.a1': 'We primarily use MetaTrader 5 (MT5), the industry-leading trading platform. MT5 is available for desktop (Windows/Mac), mobile (iOS/Android), and web browsers.',
  'faq.platform.q2': 'Is the MT5 platform free to use?',
  'faq.platform.a2': 'Yes, the MT5 platform is completely free to download and use. We provide full access to all platform features, charts, indicators, and trading tools at no additional cost.',
  'faq.platform.q3': 'Can I trade on mobile devices?',
  'faq.platform.a3': 'Absolutely! Our MT5 mobile apps for iOS and Android provide full trading functionality, real-time charts, market news, and account management on the go.',
  'faq.platform.q4': 'Do you offer demo accounts?',
  'faq.platform.a4': 'Yes, we provide free demo accounts with virtual funds so you can practice trading and familiarize yourself with the platform before investing real money.',

  // ─────────── Deposits & Withdrawals ───────────
  'faq.deposits.q1': 'What deposit methods do you accept?',
  'faq.deposits.a1': 'We accept bank wire transfers, credit/debit cards (Visa, MasterCard), and various electronic payment methods. All deposits are processed securely and efficiently.',
  'faq.deposits.q2': 'How long do deposits take to process?',
  'faq.deposits.a2': 'Credit card deposits are usually instant, while bank transfers may take 1–3 business days. Electronic payments are typically processed within a few hours.',
  'faq.deposits.q3': 'Are there any deposit fees?',
  'faq.deposits.a3': 'We do not charge fees for most deposit methods. However, your bank or payment provider may charge their own processing fees, which vary by institution.',
  'faq.deposits.q4': 'How do I withdraw my funds?',
  'faq.deposits.a4': 'Withdrawals can be requested through your client portal. Funds are typically returned to the same method used for deposit, and processing times vary by payment method.',

  // ─────────── Security ───────────
  'faq.security.q1': 'How do you protect my personal information?',
  'faq.security.a1': 'We use bank-level encryption (SSL 256-bit) to protect all data transmission. Your personal information is stored securely and never shared with third parties without consent.',
  'faq.security.q2': 'Is two-factor authentication available?',
  'faq.security.a2': 'Yes, we strongly recommend enabling two-factor authentication (2FA) for your account. This adds an extra layer of security to protect your account from unauthorized access.',
  'faq.security.q3': 'What happens if I forget my password?',
  'faq.security.a3': 'You can reset your password using the “Forgot Password” link on the login page. You’ll receive a secure reset link via email to create a new password.',
  'faq.security.q4': 'How do you ensure fair trading conditions?',
  'faq.security.a4': 'We provide transparent pricing with real-time market feeds, no dealing desk intervention, and strict regulatory compliance to ensure fair and ethical trading conditions for all clients.',
 
 // Hero
'hero.browseFAQ': 'Browse FAQ',
'hero.contactSupport': 'Contact Support',

// Contact CTA
'contactCTA.phoneTitle': 'Phone Support',
'contactCTA.phoneDesc': 'Speak directly with our specialists',
'contactCTA.callNow': 'Call Now',

'contactCTA.emailTitle': 'Email Support',
'contactCTA.emailDesc': 'Get detailed written responses',
'contactCTA.sendMsg': 'Send Message',

'contactCTA.chatTitle': 'Live Chat',
'contactCTA.chatDesc': 'Instant messaging support',
'contactCTA.available': 'Available 24/7',
'contactCTA.startChat': 'Start Chat',

'contactCTA.title': 'Still Need Help?',
'contactCTA.subtitle': 'Our expert support team is available 24/7 to assist you with any questions or concerns.',

'markets.specsTitle': 'Trading Rules',
'markets.specsDisclaimer': '* Trading conditions are subject to platform settings and market liquidity.',
'markets.spreadTypeFloating': 'Floating Spread',
'markets.points': 'points',
'markets.variableByMarket': 'Variable by market',

'markets.table.symbol': 'Symbol',
'markets.table.contractUnit': 'Contract Unit',
'markets.table.minLot': 'Min Lot',
'markets.table.maxLot': 'Max Lot',
'markets.table.leverage': 'Leverage',
'markets.table.spreadType': 'Spread Type',
'markets.table.avgSpread': 'Average Spread',
'markets.table.swapLong': 'Swap Long',
'markets.table.swapShort': 'Swap Short',

'markets.contractSections.contractSize.title': 'Contract Size',
'markets.contractSections.contractSize.items.xauusd.label': 'Gold (XAUUSD)',
'markets.contractSections.contractSize.items.xauusd.desc': 'Standard contract size for gold trading',
'markets.contractSections.contractSize.items.xagusd.label': 'Silver (XAGUSD)',
'markets.contractSections.contractSize.items.xagusd.desc': 'Standard contract size for silver trading',
'markets.contractSections.contractSize.items.gaucnh.label': 'GAUCNH',
'markets.contractSections.contractSize.items.gaucnh.desc': 'Standard contract size for offshore RMB-related FX trading',

'markets.contractSections.priceMove.title': 'Minimum Price Movement',
'markets.contractSections.priceMove.items.goldTick.label': 'Gold Tick Size',
'markets.contractSections.priceMove.items.goldTick.desc': 'Minimum price increment',
'markets.contractSections.priceMove.items.silverTick.label': 'Silver Tick Size',
'markets.contractSections.priceMove.items.silverTick.desc': 'Minimum price increment',
'markets.contractSections.priceMove.items.fxTick.label': 'FX Tick Size',
'markets.contractSections.priceMove.items.fxTick.desc': 'Minimum price increment for currency pair pricing',

'markets.contractSections.settlement.title': 'Settlement Method',
'markets.contractSections.settlement.items.type.label': 'Settlement Type',
'markets.contractSections.settlement.items.type.value': 'Cash Settlement',
'markets.contractSections.settlement.items.type.desc': 'No physical delivery required',
'markets.contractSections.settlement.items.currency.label': 'Settlement Currency',
'markets.contractSections.settlement.items.currency.desc': 'Metal instruments settle in US Dollars',
'markets.contractSections.settlement.items.fxQuote.label': 'Quote Currency',
'markets.contractSections.settlement.items.fxQuote.desc': 'GAUCNH is quoted against CNH',

'markets.contractSections.positionLimits.title': 'Position Limits',
'markets.contractSections.positionLimits.items.maxPosition.label': 'Maximum Position',
'markets.contractSections.positionLimits.items.maxPosition.desc': 'Per instrument per account',
'markets.contractSections.positionLimits.items.orderDistance.label': 'Order Distance',
'markets.contractSections.positionLimits.items.orderDistance.desc': 'Minimum distance from market price',
'markets.contractSections.positionLimits.items.execution.label': 'Execution Mode',
'markets.contractSections.positionLimits.items.execution.value': 'Market Execution',
'markets.contractSections.positionLimits.items.execution.desc': 'Orders are executed based on market liquidity conditions',

'markets.days.monday': 'Monday',
'markets.days.tuesday': 'Tuesday',
'markets.days.wednesday': 'Wednesday',
'markets.days.thursday': 'Thursday',
'markets.days.friday': 'Friday',
'markets.days.saturday': 'Saturday',
'markets.days.sunday': 'Sunday',

'markets.hours.monThu': '06:00 - 04:59',
'markets.hours.friday': '06:00 - 04:57',
'markets.hours.closed': 'Market Closed',

'markets.holidays.newYear.date': 'January 1',
'markets.holidays.newYear.event': "New Year's Day",
'markets.holidays.christmas.date': 'December 25',
'markets.holidays.christmas.event': 'Christmas Day',
'markets.holidays.independence.date': 'July 4',
'markets.holidays.independence.event': 'Independence Day (US)',
'markets.holidays.thanksgiving.date': 'November 24',
'markets.holidays.thanksgiving.event': 'Thanksgiving (US)',
'news.pageTitle': 'Financial News',
'news.pageDesc': 'Selected updates on gold, markets, rates and central banks with Traditional Chinese, Simplified Chinese and English content.',
'news.searchPlaceholder': 'Search news',
'news.empty': 'No news matched your filters',
'news.filter.all': 'All',
'news.filter.gold': 'Gold',
'news.filter.markets': 'Markets',
'news.filter.rates': 'Rates',
'news.filter.centralBank': 'Central Bank',
'news.filter.logistics': 'Logistics',

// License Page
  'license.hero.badge': 'Official Certification',
  'license.hero.title': 'Hong Kong Gold Exchange Member License',
  'license.hero.subtitle': 'GOLD Label Global Limited holds the No. 10 Member status of the Hong Kong Gold Exchange, officially recognized and regulated, providing the highest level of assurance for your precious metals trading.',
  'license.hero.badge1': 'Official Licensed Member',
  'license.hero.badge2': 'Member No. 10',
  'license.hero.badge3': 'HK Government Recognized',

  'license.details.badge': 'LICENSE DETAILS',
  'license.details.title': 'Our Official License',
  'license.details.subtitle': 'Fully licensed and regulated by the Hong Kong Gold Exchange, providing the highest standards of precious metals trading services',

  'license.image.label': 'OFFICIAL LICENSE DOCUMENT',
  'license.image.placeholder': 'License Certificate',
  'license.image.desc': 'Official Hong Kong Gold Exchange Member License',
  'license.image.verified': 'Verified by Hong Kong Gold Exchange',

  'license.member.label': 'MEMBER NUMBER',
  'license.member.title': 'Hong Kong Gold Exchange Member',

  'license.info.title': 'About Our Membership',
  'license.info.desc1': 'GOLD Label Global Limited is an official member of the Chinese Gold & Silver Exchange Society (香港黃金交易所), holding Member No. 10 status. The Exchange is Hong Kong\'s oldest and largest precious metals trading institution, established over 100 years ago and one of the most important gold trading centers globally.',
  'license.info.desc2': 'As an official member, we strictly adhere to all rules and regulatory requirements of the Exchange, ensuring every transaction takes place in a transparent, fair, and secure environment, fully protecting each client\'s interests.',

  'license.info.org.label': 'REGULATORY BODY',
  'license.info.org.value': 'Chinese Gold & Silver Exchange Society (香港黃金交易所)',
  'license.info.member.label': 'MEMBER NUMBER',
  'license.info.member.value': 'Member No. 10',
  'license.info.jurisdiction.label': 'JURISDICTION',
  'license.info.jurisdiction.value': 'Hong Kong Special Administrative Region',
  'license.info.status.label': 'LICENSE STATUS',
  'license.info.status.value': 'Active & Compliant',

  'license.features.title': 'What Our Membership Means',
  'license.features.official.title': 'Officially Recognized',
  'license.features.official.desc': 'Formally recognized by the Hong Kong Gold Exchange, meeting all regulatory requirements and industry standards',
  'license.features.trading.title': 'Authorized Trading',
  'license.features.trading.desc': 'Legally qualified to conduct precious metals trading business in full compliance',
  'license.features.regulated.title': 'Strictly Regulated',
  'license.features.regulated.desc': 'Under strict supervision of the Exchange, subject to regular compliance reviews and audits',
  'license.features.international.title': 'International Recognition',
  'license.features.international.desc': 'Exchange membership is widely recognized globally, providing international credibility',
  'license.features.market.title': 'Market Access',
  'license.features.market.desc': 'Direct participation in Exchange markets with access to best-in-class market liquidity',
  'license.features.network.title': 'Industry Network',
  'license.features.network.desc': 'Part of a vast industry network, forming reliable partnerships with other regulated financial institutions',

  'license.exchange.badge': 'ABOUT THE EXCHANGE',
  'license.exchange.title': 'Chinese Gold & Silver Exchange Society — Over a Century of Heritage',
  'license.exchange.desc1': 'The Chinese Gold & Silver Exchange Society (香港黃金交易所) was established in 1910 and is Hong Kong\'s oldest precious metals trading institution. For over a century, it has been the core institution of Hong Kong and Asia\'s precious metals market.',
  'license.exchange.desc2': 'The Exchange maintains a rigorous membership system — only qualified enterprises that pass thorough vetting may become official members. Our company\'s successful attainment of Member No. 10 status fully demonstrates our professional expertise and reputation.',

  'license.exchange.stat1.value': '1910',
  'license.exchange.stat1.label': 'Exchange Founded',
  'license.exchange.stat2.value': '100+',
  'license.exchange.stat2.label': 'Years of Heritage',
  'license.exchange.stat3.value': 'HK$80B',
  'license.exchange.stat3.label': 'Daily Trading Volume',
  'license.exchange.stat4.value': 'Global',
  'license.exchange.stat4.label': 'International Recognition',

  'license.exchange.img.caption': 'Chinese Gold & Silver Exchange Society',
  'license.exchange.img.sub': 'Hong Kong\'s Premier Precious Metals Exchange',
  'license.exchange.badge.number': 'Member No. 10',
  "hero.cta.accountOpening": "Account Opening Process",
  "hero.cta.depositWithdraw": "Deposit & Withdrawal Process",
  "androidDownload.title": "Download MetaTrader 5",
  "androidDownload.description": "You will be redirected to Google Play automatically. If Google Play is unavailable on your device, you can download the APK directly.",
  "androidDownload.autoRedirect": "Redirecting to Google Play in {{seconds}} seconds",
  "androidDownload.openGooglePlay": "Open Google Play",
  "androidDownload.downloadApk": "Download APK Directly",
  "androidDownload.hint": "If Google Play does not open, please tap “Download APK Directly”.",
  'windowsDownload.pageTitle': 'Windows MT5 Download',
  'windowsDownload.pageDesc': 'Please choose the installer version that suits you.',
  'windowsDownload.badge': 'Windows MT5 Download',
  'windowsDownload.title': 'Choose your installer package',
  'windowsDownload.description': 'Please choose a Windows MT5 installer. The Gold Label Smooth Stable Version is recommended for Mainland China and Hong Kong users. You may also use the original official installer.',
  'windowsDownload.smoothTitle': '1. Gold Label Smooth Stable Version',
  'windowsDownload.smoothDesc': 'Recommended for Mainland China / Hong Kong Windows users. Users in other regions may also use this version if the official installer is inconvenient.',
  'windowsDownload.smoothButton': 'Download Gold Label Smooth Stable Version',
  'windowsDownload.officialTitle': '2. MetaQuotes Official Installer',
  'windowsDownload.officialDesc': 'Original download link. Mainland China Windows users may occasionally encounter installation issues; users in other regions are not affected.',
  'windowsDownload.officialButton': 'Download Official Installer',

  // Economic calendar explorer
  'calendar.hongKongTime': 'Hong Kong time (GMT+8)',
  'calendar.previousDays': 'Previous 7 days',
  'calendar.nextDays': 'Next 7 days',
  'calendar.today': 'Today',
  'calendar.jumpToDate': 'Jump to date',
  'calendar.completeView': 'Complete view',
  'calendar.allDays': 'All 7 days',
  'calendar.events': 'events',
  'calendar.impactAll': 'All impact',
  'calendar.impactHigh': 'High',
  'calendar.impactMedium': 'Medium',
  'calendar.impactLow': 'Low',
  'calendar.searchPlaceholder': 'Search event, country or currency',
  'calendar.eventsFound': 'events shown',
  'calendar.lastUpdated': 'Last updated',
  'calendar.loadError': 'The economic calendar is temporarily unavailable.',
  'calendar.noEvents': 'No economic events match this view.',
  'calendar.tryAnotherDate': 'Choose another day or clear the filters.',
  'calendar.time': 'Time',
  'calendar.impact': 'Impact',
  'calendar.released': 'Released',
  'calendar.pending': 'Pending',
  'calendar.disclaimer': 'Calendar times use Hong Kong time. Figures may be revised and are provided for information only.',
  'news.tab.newsDesc': 'Latest market headlines, gold analysis and educational content',
  'news.tab.calendarDesc': 'Review important economic events and releases across nearby dates',
  'news.autoRefresh': 'News information refreshes automatically',

  'news.tabs.news': 'News',
  'news.tabs.calendar': 'Economic Calendar',

};

export default common;
